import Logo from "./Logo";

export default function Brand({ subtitle = "پنل مدیریت", size = 42 }) {
  return (
    <span className="brand">
      <Logo size={size} />
      <span className="brand-text">
        <span>سامانه ایجنت‌ها</span>
        <span>{subtitle}</span>
      </span>
    </span>
  );
}
